import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Table } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import PropTypes from 'prop-types';
import {
    EMPLOYEE_COUNT,
    OVERRIDE_POINTS,
    NO_CALL_OFF_POINTS,
    NO_CALL_OFF_SHIFTS,
    ON_TIME_POINTS,
    PARTICIPATION,
    QUARTERLY,
    REWARD_BUDGET,
    REWARD_VALUE,
    SHIFTS_PICKED_UP,
    SURVEY
} from '../actions/types';

class Printable extends Component {

    inBudget(cost) {
        const { rewardBudget } = this.props;
        if (cost > rewardBudget) {
            return <Badge variant="danger">Over Budget</Badge>;
        } else {
            return <Badge variant="success">In Budget</Badge>;
        }
    }

    render() {
        const {
            employeeCount,
            overridePoints,
            participation,
            rewardBudget,
            rewardValue,
            noCallOffPoints,
            noCallOffShifts,
            onTimePoints,
            quarterly,
            survey,
            valueAveTenure,
            valueOverrideRewardsPerMonth,
            valueOverrideRewardsPerMonthDistributed,
            valueMaxNoCallOffs,
            valueMaxOnTime,
            valueMaxSurvey,
            valueMaxTotalPoints,
            valueMaxTotalPointsEst,
            valuePointsPerReward,
            valueRewardsDistributedEst,
            valueRewardsDistributedValueEst,
            valueOverrideRewardsEst,
            valueOverrideRewardsValueEst,
            valueRewardsPerMonth,
            valueRoundedPointsPerReward,
            valueRoundedPointsPerRewardDistributed } = this.props;
        return (
            <Row>
                <Col md={12}>
                    <Table striped bordered condensed='true' hover>
                        <thead>
                            <tr>
                                <th width="66%">Overview Configuration Parameter</th>
                                <th width="33%">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Number of Employees:</td>
                                <td>{employeeCount}</td>
                            </tr>
                            <tr>
                                <td>Monthly Reward Budget (in Dollars):</td>
                                <td>{rewardBudget}</td>
                            </tr>
                            <tr>
                                <td>Value of Reward (in Dollars):</td>
                                <td>{rewardValue}</td>
                            </tr>
                            <tr>
                                <td>Approximate Participation (in Percentage):</td>
                                <td>{participation}</td>
                            </tr>
                            <tr>
                                <td>Manually Set Point Value (May override budget):</td>
                                <td>{overridePoints}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <Table striped bordered condensed='true' hover>
                        <thead>
                            <tr>
                                <th width="66%">Reward Configuration Parameter</th>
                                <th width="33%">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Consecutive No Call-Offs Shifts:</td>
                                <td>{noCallOffShifts}</td>
                            </tr>
                            <tr>
                                <td>Consecutive No Call-Offs Points Awarded:</td>
                                <td>{noCallOffPoints}</td>
                            </tr>
                            <tr>
                                <td>On-Time Shift Points Awarded:</td>
                                <td>{onTimePoints}</td>
                            </tr>
                            <tr>
                                <td>Complete Survey Instance:</td>
                                <td>{survey}</td>
                            </tr>
                            <tr>
                                <td>Quarterly Tenure for 6 or more months:</td>
                                <td>{quarterly}</td>
                            </tr>
                            {/* Temporarily commented out for 0.8.2
                            <tr>
                                <td>Shifts Picked Up:</td>
                                <td>{shiftsPickedUp}</td>
                            </tr>
                            */}
                        </tbody>
                    </Table>
                    <Table striped bordered condensed='true' hover>
                        <thead>
                            <tr>
                                <th width="66%">Budgeted Automatic Settings</th>
                                <th width="33%">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Max Total Rewards Distributed Per Month:</td>
                                <td>{valueRewardsPerMonth.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Exact Number of Points Per Reward:</td>
                                <td>{valuePointsPerReward.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Rounded of Points Per Reward:</td>
                                <td>{valueRoundedPointsPerReward.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Estimated Budget based on rounded value:</td>
                                <td>${valueRoundedPointsPerRewardDistributed.toFixed(2)} {this.inBudget(valueRoundedPointsPerRewardDistributed)}</td>
                            </tr>
                            <tr>
                                <td>{participation.toFixed(0)}% Part. Estimated Rewards Distributed:</td>
                                <td>{valueRewardsDistributedEst.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>{participation.toFixed(0)}% Part. Estimated Budget:</td>
                                <td>${valueRewardsDistributedValueEst.toFixed(2)} {this.inBudget(valueRewardsDistributedValueEst)}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <Table striped bordered condensed='true' hover>
                        <thead>
                            <tr>
                                <th width="66%">Manual Settings</th>
                                <th width="33%">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Estimated Maximum Rewards Distributed Per Month:</td>
                                <td>{valueOverrideRewardsPerMonth.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Specified Number of Points Per Reward:</td>
                                <td>{overridePoints.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Estimated Total Cost Per Month:</td>
                                <td>${valueOverrideRewardsPerMonthDistributed.toFixed(2)} {this.inBudget(valueOverrideRewardsPerMonthDistributed)}</td>
                            </tr>
                            <tr>
                                <td>{participation.toFixed(0)}% Part. Estimated Manual Rewards Distributed:</td>
                                <td>{valueOverrideRewardsEst.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>{participation.toFixed(0)}% Part. Estimated Manual Budget:</td>
                                <td>${valueOverrideRewardsValueEst.toFixed(2)} {this.inBudget(valueOverrideRewardsValueEst)}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <Table striped bordered condensed='true' hover>
                        <thead>
                            <tr>
                                <th width="50%">Reward Points Calculated Values</th>
                                <th width="25%">Total</th>
                                <th width="25%">Per Employee</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Average Total Monthly Tenure Reward:</td>
                                <td>{valueAveTenure.toFixed(2)}</td>
                                <td>{(valueAveTenure / employeeCount).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Max Total Monthly No Call-Off Reward:</td>
                                <td>{valueMaxNoCallOffs.toFixed(2)}</td>
                                <td>{(valueMaxNoCallOffs / employeeCount).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Max Total Monthly On-Time Reward:</td>
                                <td>{valueMaxOnTime.toFixed(2)}</td>
                                <td>{(valueMaxOnTime / employeeCount).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Max Total Monthly Survey Reward:</td>
                                <td>{valueMaxSurvey.toFixed(2)}</td>
                                <td>{(valueMaxSurvey / employeeCount).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Max Total Monthly Reward:</td>
                                <td>{valueMaxTotalPoints.toFixed(2)}</td>
                                <td>{(valueMaxTotalPoints / employeeCount).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>{participation.toFixed(0)}% Participation Estimated Monthly Reward:</td>
                                <td>{valueMaxTotalPointsEst.toFixed(2)}</td>
                                <td>{(valueMaxTotalPointsEst / employeeCount).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <Table striped bordered condensed='true' hover>
                        <thead>
                            <tr>
                                <th width="66%">Estimated time between rewards</th>
                                <th width="33%">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Minimum months between rewards for employee:</td>
                                <td>{(overridePoints / (valueMaxTotalPoints / employeeCount)).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Estimated months based on participation:</td>
                                <td>{(overridePoints / (valueMaxTotalPointsEst / employeeCount)).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        );
    }
}

Printable.propTypes = {
    employeeCount: PropTypes.number,
    overridePoints: PropTypes.number,
    noCallOffPoints: PropTypes.number,
    noCallOffShifts: PropTypes.number,
    onTimePoints: PropTypes.number,
    participation: PropTypes.number,
    quarterly: PropTypes.number,
    rewardBudget: PropTypes.number,
    rewardValue: PropTypes.number,
    shiftsPickedUp: PropTypes.number,
    survey: PropTypes.number,
    valueAveTenure: PropTypes.number,
    valueOverrideRewardsPerMonth: PropTypes.number,
    valueOverrideRewardsPerMonthDistributed: PropTypes.number,
    valueMaxNoCallOffs: PropTypes.number,
    valueMaxOnTime: PropTypes.number,
    valueMaxSurvey: PropTypes.number,
    valueMaxTotalPoints: PropTypes.number,
    valueMaxTotalPointsEst: PropTypes.number,
    valuePointsPerReward: PropTypes.number,
    valueRewardsDistributedEst: PropTypes.number,
    valueRewardsDistributedValueEst: PropTypes.number,
    valueOverrideRewardsEst: PropTypes.number,
    valueOverrideRewardsValueEst: PropTypes.number,
    valueRewardsPerMonth: PropTypes.number,
    valueRoundedPointsPerReward: PropTypes.number,
    valueRoundedPointsPerRewardDistributed: PropTypes.number
};

function mapStateToProps(state) {
    return {
        employeeCount: state.calc.get(EMPLOYEE_COUNT),
        overridePoints: state.calc.get(OVERRIDE_POINTS),
        noCallOffPoints: state.calc.get(NO_CALL_OFF_POINTS),
        noCallOffShifts: state.calc.get(NO_CALL_OFF_SHIFTS),
        onTimePoints: state.calc.get(ON_TIME_POINTS),
        participation: state.calc.get(PARTICIPATION),
        quarterly: state.calc.get(QUARTERLY),
        rewardBudget: state.calc.get(REWARD_BUDGET),
        rewardValue: state.calc.get(REWARD_VALUE),
        shiftsPickedUp: state.calc.get(SHIFTS_PICKED_UP),
        survey: state.calc.get(SURVEY),
        valueAveTenure: state.calc.get('valueAveTenure'),
        valueOverrideRewardsPerMonth: state.calc.get('valueOverrideRewardsPerMonth'),
        valueOverrideRewardsPerMonthDistributed: state.calc.get('valueOverrideRewardsPerMonthDistributed'),
        valueMaxNoCallOffs: state.calc.get('valueMaxNoCallOffs'),
        valueMaxOnTime: state.calc.get('valueMaxOnTime'),
        valueMaxSurvey: state.calc.get('valueMaxSurvey'),
        valueMaxTotalPoints: state.calc.get('valueMaxTotalPoints'),
        valueMaxTotalPointsEst: state.calc.get('valueMaxTotalPointsEst'),
        valuePointsPerReward: state.calc.get('valuePointsPerReward'),
        valueRewardsDistributedEst: state.calc.get('valueRewardsDistributedEst'),
        valueRewardsDistributedValueEst: state.calc.get('valueRewardsDistributedValueEst'),
        valueOverrideRewardsEst: state.calc.get('valueOverrideRewardsEst'),
        valueOverrideRewardsValueEst: state.calc.get('valueOverrideRewardsValueEst'),
        valueRewardsPerMonth: state.calc.get('valueRewardsPerMonth'),
        valueRoundedPointsPerReward: state.calc.get('valueRoundedPointsPerReward'),
        valueRoundedPointsPerRewardDistributed: state.calc.get('valueRoundedPointsPerRewardDistributed')
    };
}

export default connect(mapStateToProps, {})(Printable);
